import type { FieldValue } from './api/types';

/**
 * Which frame of the capture a value was read off, as the operator sees it.
 *
 * A field's evidence names an `assetKey` (INTERFACES.md section 1), and the
 * capture's `assetKeys` are in the order the operator shot them, so the
 * position of the key is the frame number. The review console labels the
 * same values the same way (apps/classification-ui/src/features/
 * capture-review/lib/frame-labels.js), so an operator and a reviewer
 * discussing "frame 2" mean one photograph.
 *
 * Returns null for a single-frame capture, where "Frame 1" says nothing,
 * and for a value no evidence ties to a stored frame.
 */
export function frameLabel(field: FieldValue, assetKeys: string[]): string | null {
  if (!Array.isArray(assetKeys) || assetKeys.length < 2) return null;

  const numbers = [
    ...new Set(
      (field.evidence ?? [])
        .map((reference) => assetKeys.indexOf(reference.assetKey ?? ''))
        .filter((index) => index >= 0)
        .map((index) => index + 1)
    ),
  ].sort((a, b) => a - b);

  if (numbers.length === 0) return null;
  return numbers.length === 1 ? `Frame ${numbers[0]}` : `Frames ${numbers.join(', ')}`;
}
